import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

export interface WhatsAppReportSummary {
  conversations: number;
  conversations_delta_pct: number | null;
  incoming: number;
  outgoing: number;
  outgoing_templates: number;
  delivered: number;
  delivered_pct: number | null;
  read: number;
  read_pct_of_delivered: number | null;
  failed: number;
  failed_pct: number | null;
  failed_outside_window: number;
}

export interface WhatsAppReportAgentRow {
  user_id: number;
  user_name: string;
  conversations: number;
  messages: number;
  median_first_response_seconds: number | null;
  resolved: number;
  converted_orders: number;
  converted_revenue: number;
}

export interface WhatsAppReportFailure {
  code: string | null;
  label: string;
  count: number;
}

export interface WhatsAppReport {
  period: { days: number; start: string; end: string };
  summary: WhatsAppReportSummary;
  median_first_response_seconds: number | null;
  conversations_with_reply: number;
  median_resolution_seconds: number | null;
  resolved_count: number;
  revenue: { orders: number; amount: number };
  by_agent: WhatsAppReportAgentRow[];
  failure_breakdown: WhatsAppReportFailure[];
}

interface ApiEnvelope<T> {
  success: boolean;
  message?: string;
  data: T;
}

class WhatsAppReportService {
  private base = `${API_BASE_URL}/whatsapp-report`;

  private getAuthHeaders() {
    let token = Cookies.get('crm_auth_token');
    if (!token && import.meta.env.VITE_BEARER_TOKEN) {
      token = import.meta.env.VITE_BEARER_TOKEN;
    }
    return { Authorization: `Bearer ${token}` };
  }

  async getReport(days: number): Promise<WhatsAppReport | null> {
    const res = await axios.get<ApiEnvelope<WhatsAppReport>>(this.base, {
      params: { days },
      headers: this.getAuthHeaders(),
    });
    return res.data.success ? res.data.data : null;
  }
}

export const whatsappReportService = new WhatsAppReportService();
export default whatsappReportService;
